import axios from "axios";

export const getBrands = (search?: string | null) =>
  axios
    .get("/brands", {
      params: { search },
    })
    .then((res) => res.data);
